export default [
  {
    path: 'refiningDetails/:id',
    name: 'RefiningDetails',
    meta: {
      title: '大咖讲堂'
    },
    component: () =>
      import('../views/exerland/refining/details.vue')
  },
  {
    path: 'introduction',
    name: 'Introduction',
    component: () =>
      import(
        '../views/exerland/refining/Introduction.vue'
      )
  }
]
